import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _AdquisitionContract } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_DATE, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { AccountEditor } from "../../../editor/AccountEditor";
import { toast } from "react-toastify";

interface Props {
    idContract?: number;
    idAccount?: number;
    onChange: any;
    label?: string;
    renderContract?: string;
}

export const EditorAdquisitionContractSelect = ({ idContract, idAccount, renderContract, onChange, label }: Props) => {

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [listaResult, setListaResult] = useState<any>([]);
    const { instance, setBean, bean, lista, setLista } = useDataBean(_AdquisitionContract);
    const [idAcc, setIDAcc] = useState<number>(null);
    const [render, setRender] = useState<string>('');

    useEffect(() => { if (renderContract) setRender(renderContract) }, [renderContract])

    useEffect(() => {
        if (idAccount) {
            setIDAcc(idAccount)
        }
    }, [idAccount])

    useEffect(() => {
        getLista();
    }, [idAcc])


    const getLista = () => {
        const props = {
            IDAccount: idAcc,
            State: 1
        }
        instance.getAdquisitionContractRender(null, null, props, null, null).then(
            (resp) => {
                setLista(resp)
                console.log(resp)
            }
        )
    }

    const headMulti = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: true },
        { title: 'Valor Contrato', property: 'ContractValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor CDP', property: 'CDPValue', visible: false },
        { title: 'Fecha Contrato', property: 'SeleccionDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'EndContractDate', visible: true, mask: MASK_DATE },
        { title: 'Código contrato', property: 'InternalCode', visible: false },
        { title: 'Proveedor', property: 'Name1', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'No CDP', property: 'NoCDP', visible: false },
        { title: 'Fecha CDP', property: 'DateCDP', visible: false },
        { title: 'No registro presupuestal', property: 'NoRegistroPresupuestal', visible: false },
        { title: 'Fecha registro presupuestal', property: 'DateRegPresupuestal', visible: false },
    ]
    const abrirmodal = () => {
        setModal({ ...modal, "view": true, "name": "Selecciona una Fila*" });
    }

    const returnValue = () => {
        if (onChange && bean.IDAdquisitionContract) {
            onChange(bean);
            setRender(`${bean.InternalCode} - ${bean.Name1}`)
            setModal({ ...modal, "view": false });
        } else {
            toast.error("Contrato no valido");
        }
        // setModa
    }

    return (
        <>

            <label >{label ?? 'Contrato'}</label>
            <input type="text" className='form-control' readOnly placeholder={render} onClick={abrirmodal} />

            <Modal modal={modal} updateModal={setModal} eventModal={returnValue}>
                <label>{label ?? "Contratos de Adquisición"}</label>
                <AccountEditor idAccount={idAcc} label="Tercero" onChange={(e) => { setIDAcc(e.IDAccount) }} />
                <BasicTable head={headMulti} body={lista} rowSet={setBean} />
            </Modal>
        </>
    )
}